import React from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import Icon from 'material-ui/Icon'
import { toast } from 'react-toastify'
import { APP_CONFIG } from '../../../config'
import Button from 'material-ui/Button'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'

import Grid from 'material-ui/Grid'
import List, { ListItem, ListItemText } from 'material-ui/List'

import { withStyles } from 'material-ui/styles'
import styles from './styles'

import { ModalHeader, ModalContents, ModalFooter } from '../../common/modal'

class LantekUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lantekfiles: null,
      testFileArray: null,
      jobFileArray: null,
      errors: {},
      allowedExtensions: '',
      maxFileSize: 0,
    }
    this.handleClose = this.handleClose.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
    this.handleChange = this.handleChange.bind(this)

  }

  componentDidMount() {
    const {fileUploadSettings} = this.props;
    if (fileUploadSettings && fileUploadSettings.allowedLantekExtensions) {

      // fileUploadSettings.allowedLantekExtensions is an array of strings
      // Add a dot to the beginning of each string if it doesn't already have one
      const allowedLantekExtensions = fileUploadSettings.allowedLantekExtensions.map(ext => {
        if (ext[0] !== '.') {
          return '.' + ext
        }
        return ext
      });

      this.setState({
        allowedExtensions: allowedLantekExtensions,
        maxFileSize: fileUploadSettings.maxFileSize || APP_CONFIG.maxFileUploadSize
      })
    }
  }

  handleClose() {
    this.props.onClose()
  }
  handleUpload() {
    let fd = new FormData();
    let lantekfiles = { ...this.state.lantekfiles }
    Object.keys(lantekfiles).forEach(key => {
      fd.append('file', lantekfiles[key])
    });
    this.props.onUpload(fd)
  }

  handleChange(e) {
    if (e.target.type == 'file' && e.target.files.length) {
      const totalBytes = Object.keys(e.target.files).reduce((total, file) => (total + e.target.files[file].size), 0)
      // 1 MB = 1048576 bytes

      const { fileUploadSettings } = this.props;

      const fileSizeInMB = Math.round(totalBytes / 1048576);
      const maxAllowedFileSizeInMB =  fileUploadSettings.maxFileSize || APP_CONFIG.maxFileUploadSize;
      const allowedExtensions = fileUploadSettings.allowedLantekExtensions;

      if (fileSizeInMB >= maxAllowedFileSizeInMB) {
        toast.error(` ${this.props.translate("jobs_upload_file_size_error", { value: maxAllowedFileSizeInMB })}`, {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
        })
        document.getElementById("lantekfiles").value = "";
        this.setState({
          lantekfiles: null,
          testFileArray: null,
          jobFileArray: null
        })
        return
      }

      if (allowedExtensions && allowedExtensions.length) {
        const fileName = e.target.files[0].name;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          toast.error(` ${this.props.translate("jobs_upload_file_extension_error", { value: allowedExtensions.join(', ') })}`, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
          })
          document.getElementById("lantekfiles").value = "";
          this.setState({
            lantekfiles: null,
            testFileArray: null,
            jobFileArray: null
          })
          return
        }
      }

      this.setState({
        [e.target.name]: e.target.files,
        testFileArray: Array.from(e.target.files).filter((file) => (file.name.split('.').pop().toLowerCase() !== 'job')),
        jobFileArray: Array.from(e.target.files).filter((file) => (file.name.split('.').pop().toLowerCase() === 'job'))
      })
    }
  }

  render() {
    const {
      classes,
      translate
    } = this.props

    const {
      lantekfiles,
      testFileArray,
      jobFileArray,
      errors
    } = this.state

    let $fileLists = (testFileArray && testFileArray.length) ? (
      <React.Fragment>
        <Grid container style={{ marginTop: '30px' }}>
          <Grid item xs={12} sm={6}>
            <Typography type="caption">{translate('job_upload_lantek_tests_file_label')}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography type="caption" align="right">{translate('job_upload_lantek_tests_file_total')} - {testFileArray.length}</Typography>
          </Grid>
        </Grid>
        <List disablePadding={true} className={classes.scrollableList}>
          {
            Array.from(testFileArray).map((val, i) => {
              return (<ListItem key={`testfilenames-${i}`}><ListItemText primary={val.name} /></ListItem>)
            })
          }
        </List>
      </React.Fragment>
    ) : (null)

    let $jobFile = (jobFileArray && jobFileArray.length) ? (
      <React.Fragment>
        <Typography type="caption">{translate('job_upload_lantek_job_file_label')}</Typography>
        <Typography type="subheading">{jobFileArray[0].name} </Typography>
      </React.Fragment>
    ) : (null)

    return (
      <Modal open={true} onClose={this.handleClose.bind(this)}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit" className={classes.modalHeader}>
                {translate('tooltip_import_lantek')}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              {(jobFileArray && jobFileArray.length === 0) ? (
                <div className={classes.warning}>
                  <Typography type="subheading" color="inherit">
                    {translate('general_warning')}
                  </Typography>
                  <Typography type="body1" color="inherit">
                    {translate('job_upload_lantek_warn_nojob')}
                  </Typography>
                </div>
              ) : (null)}

              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  fullWidth
                  error={errors.lantekfiles ? true : false}
                >
                  <Input
                    className={classes.upload}
                    id="lantekfiles"
                    type="file"
                    name="lantekfiles"
                    onChange={this.handleChange}
                    inputProps={{
                      name: "lantekfiles",
                      multiple: true,
                      accept: this.state.allowedExtensions ? this.state.allowedExtensions.join(',') : null
                    }}
                  />
                  <FormHelperText id="lantekfiles-helper-text">{translate('job_upload_lantek_helptext')}</FormHelperText>
                  <FormHelperText id="lantekfiles-helper-text-2">{translate("security_file_upload_settings_allowed_lantek_extensions")}: {this.state.allowedExtensions ? this.state.allowedExtensions.join(',') : null}</FormHelperText>
                  <FormHelperText id="lantekfiles-helper-text-3">{translate("security_file_upload_settings_max_file_size")}: {this.state.maxFileSize ? this.state.maxFileSize : null} MB</FormHelperText>
                </FormControl>
                {$fileLists}
                {$jobFile}
              </form>

            </ModalContents>
            <ModalFooter classes={classes}>

              {testFileArray ? (<Button
                className={classes.submit}
                raised
                color="primary"
                type="submit"
                onClick={this.handleUpload}
              >
                {translate('general_import')}
              </Button>) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }
}
export default withStyles(styles)(LantekUpload)



// WEBPACK FOOTER //
// ./src/components/jobs/lantekupload/index.js